import { createSlice } from "@reduxjs/toolkit";
import {
  createTalentoThunk,
  getTalentoByIdThunk,
  getTalentosThunk,
  toggleTalentoActiveThunk,
  updateTalentoThunk,
} from "./talentos.thunks";

const initialState = {
  list: [],
  loading: false,
  error: null,
  page: 1,
  pageSize: 10,
  totalPages: 1,
  count: 0,
  next: null,
  previous: null,
  maxPageReached: 1,
  search: "",

  selectedTalento: null,
  selectedTalentoLoading: false,
  selectedTalentoError: null,
  viewModalOpen: false,

  formModalOpen: false,
  formMode: "create", // "create" | "edit"
  formLoading: false,
  formError: null,

  confirmModalOpen: false,
  toggleTalentoId: null,
  toggling: false,
};

const talentosSlice = createSlice({
  name: "talentos",
  initialState,
  reducers: {
    clearTalentosError: (state) => {
      state.error = null;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
      state.page = 1; // Reset a página 1 al buscar
    },
    openViewModal: (state) => {
      state.viewModalOpen = true;
    },
    closeViewModal: (state) => {
      state.viewModalOpen = false;
      state.selectedTalento = null;
    },
    openFormModal: (state, action) => {
      state.formModalOpen = true;
      state.formMode = action.payload?.mode || "create";
      if (action.payload?.talento) {
        state.selectedTalento = action.payload.talento;
      }
      state.formError = null;
    },
    closeFormModal: (state) => {
      state.formModalOpen = false;
      state.selectedTalento = null;
      state.formError = null;
    },
    openConfirmToggle: (state, action) => {
      state.confirmModalOpen = true;
      state.toggleTalentoId = action.payload.id;
    },
    closeConfirmToggle: (state) => {
      state.confirmModalOpen = false;
      state.toggleTalentoId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET ALL
      .addCase(getTalentosThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTalentosThunk.fulfilled, (state, action) => {
        const { results, count, next, previous } = action.payload;

        state.loading = false;
        state.list = results;
        state.count = count;
        state.next = next;
        state.previous = previous;

        state.maxPageReached = Math.max(state.maxPageReached, state.page);
      })
      .addCase(getTalentosThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // GET BY ID
      .addCase(getTalentoByIdThunk.pending, (state) => {
        state.selectedTalentoLoading = true;
        state.selectedTalentoError = null;
      })
      .addCase(getTalentoByIdThunk.fulfilled, (state, action) => {
        state.selectedTalentoLoading = false;
        state.selectedTalento = action.payload;
      })
      .addCase(getTalentoByIdThunk.rejected, (state, action) => {
        state.selectedTalentoLoading = false;
        state.selectedTalentoError = action.payload;
      })

      // CREATE
      .addCase(createTalentoThunk.pending, (state) => {
        state.formLoading = true;
        state.formError = null;
      })
      .addCase(createTalentoThunk.fulfilled, (state) => {
        state.formLoading = false;
        state.formModalOpen = false;
        state.selectedTalento = null;
      })
      .addCase(createTalentoThunk.rejected, (state, action) => {
        state.formLoading = false;
        state.formError = action.payload;
      })

      // UPDATE
      .addCase(updateTalentoThunk.pending, (state) => {
        state.formLoading = true;
        state.formError = null;
      })
      .addCase(updateTalentoThunk.fulfilled, (state) => {
        state.formLoading = false;
        state.formModalOpen = false;
        state.selectedTalento = null;
      })
      .addCase(updateTalentoThunk.rejected, (state, action) => {
        state.formLoading = false;
        state.formError = action.payload;
      })

      // TOGGLE ACTIVE
      .addCase(toggleTalentoActiveThunk.pending, (state) => {
        state.toggling = true;
      })
      .addCase(toggleTalentoActiveThunk.fulfilled, (state) => {
        state.toggling = false;
        state.confirmModalOpen = false;
        state.toggleTalentoId = null;
      })
      .addCase(toggleTalentoActiveThunk.rejected, (state, action) => {
        state.toggling = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearTalentosError,
  setPage,
  setSearch,
  openViewModal,
  closeViewModal,
  openFormModal,
  closeFormModal,
  openConfirmToggle,
  closeConfirmToggle,
} = talentosSlice.actions;

export default talentosSlice.reducer;
